import React from "react";
import { NavLink } from "react-router";
import { useTranslation } from "react-i18next";
import { RoutesPaths } from "../Router/constant";

export default function Footer() {
  const { t } = useTranslation();
  const services = t("common.footer.services", { returnObjects: true });

  return (
    <footer className="footer-section">
      <div className="main-container">
        <div className="row footer-top">
          <div className="col-lg-4">
            <img src="/images/pro-vest-fsp-logo.png" alt="PRO-VEST FSP" width="2069" height="424" className="footer-logo mb-3" />

            <p className="footer-text m-0 f-s-16 l-h-24 c-p">
              {t("common.company.shortDescription")}
            </p>
          </div>

          <div className="col-lg-2 offset-lg-3">
            <h6 className="m-0 f-w-600 f-s-20 l-h-24 c-p">
              {t("common.footer.quickLinks")}
            </h6>
            <ul className="footer-links">
              <li>
                <NavLink className="f-s-16 l-h-24" to={RoutesPaths.HOME}>
                  {t("common.footer.links.home")}
                </NavLink>
              </li>
              <li>
                <NavLink className="f-s-16 l-h-24" to={RoutesPaths.ABOUT}>
                  {t("common.footer.links.about")}
                </NavLink>
              </li>
              <li>
                <NavLink className="f-s-16 l-h-24" to={RoutesPaths.BANNER}>
                  {t("common.footer.links.services")}
                </NavLink>
              </li>
              <li>
                <NavLink className="f-s-16 l-h-24" to={RoutesPaths.BANNER}>
                  {t("common.footer.links.newsroom")}
                </NavLink>
              </li>
              <li>
                <NavLink className="f-s-16 l-h-24" to={RoutesPaths.CONTACT}>
                  {t("common.footer.links.contact")}
                </NavLink>
              </li>
            </ul>
          </div>

          <div className="col-lg-3">
            <h6 className="m-0 f-w-600 f-s-20 l-h-24 c-p">
              {t("common.footer.servicesTitle")}
            </h6>
            <ul className="footer-links">
              {services.map((service) => (
                <li key={service}>
                  <NavLink className="f-s-16 l-h-24" to={RoutesPaths.BANNER}>
                    {service}
                  </NavLink>
                </li>
              ))}
            </ul>
          </div>
        </div>

        <div className="footer-contact row g-3">
          <div className="col-lg-4 ps-lg-0">
            <div className="contact-box">
              <span className="icon">
                <img src="/images/icon-phone-call.png" alt="" />
              </span>
              <div>
                <p className="m-0 f-w-600 f-s-16 c-p">
                  {t("common.footer.phoneLabel")}
                </p>
                <p className="m-0 f-s-16 l-h-20 c-p">
                  +244 947885958 / +244 947885958
                </p>
              </div>
            </div>
          </div>

          <div className="col-lg-4">
            <div className="contact-box">
              <span className="icon">
                <img src="/images/icon-location.png" alt="" />
              </span>
              <p className="m-0 f-s-16 l-h-20 c-p">
                {t("common.company.locationLuanda")}
              </p>
            </div>
          </div>

          <div className="col-lg-4 pe-lg-0">
            <div className="contact-box">
              <span className="icon">
                <img src="/images/icon-location.png" alt="" />
              </span>
              <p className="m-0 f-s-16 l-h-20 c-p">
                {t("common.company.locationCapeTown")}
              </p>
            </div>
          </div>
        </div>

        <div className="footer-bottom">
          <div className="d-lg-flex justify-content-between align-items-center">
            <div className="social-icons">
              <NavLink>
                <img src="/images/social-icon-x.png" alt="" />
              </NavLink>
              <NavLink>
                <img src="/images/social-icon-in.png" alt="" />
              </NavLink>
              <NavLink>
                <img src="/images/social-icon-f.png" alt="" />
              </NavLink>
              <NavLink>
                <img src="/images/social-icon-g.png" alt="" />
              </NavLink>
              <NavLink>
                <img src="/images/social-icon-b.png" alt="" />
              </NavLink>
              <NavLink>
                <img src="/images/social-icon-d.png" alt="" />
              </NavLink>
            </div>
            <div className="footer-legal-links">
              <NavLink className="f-s-16 l-h-24" to={RoutesPaths.PRIVACY_POLICY}>
                {t("common.footer.legal.privacy")}
              </NavLink>
              <NavLink className="f-s-16 l-h-24" to={RoutesPaths.TERMS_AND_CONDITIONS}>
                {t("common.footer.legal.terms")}
              </NavLink>
            </div>
          </div>
          <div className="text-center">
            <p className="mb-0 mt-3 f-s-12 l-h-24 c-p">
              {t("common.footer.copyright")}
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
}
